import { connect } from 'react-redux';
import TinyUsers from '../views/tiny/TinyUsers';

// 這頁自己用 axios 打 /api/users，不經 redux ——
// 與 TinyClubConfig / TinyEcoBot 等較新的頁面一致。
function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, () => ({}))(TinyUsers);
